import { IBillingDetail } from '@nkr/models/index';

interface IProps {
    data: IBillingDetail,
    isRecipientCenter: boolean,
    onViewCharges: (donorId: number) => void
}

const SubmittedByRecipientCenterRow = (props: IProps) => {
    const handleViewCharges = () => {
        props.onViewCharges(props.data.billableNephrectomy.donor.id);
    };

    const { physicianCharges, anesthesiaCharges, hospitalCharges, billableNephrectomy, claimType } = props.data;
    const total = physicianCharges + anesthesiaCharges + hospitalCharges;

    return (
        <tr>
            <td>{billableNephrectomy.transplantDate}</td>
            <td>{billableNephrectomy.chainId}&nbsp;/&nbsp;{billableNephrectomy.clusterNumber}&nbsp;/&nbsp;{billableNephrectomy.positionNumber}</td>
            <td>{billableNephrectomy.donor.center.alias} {billableNephrectomy.donor.rdnCenterId > 0 ? <span style={{ color: 'darkred' }}>({billableNephrectomy.donor.rdnCenterAlias})</span> : null}</td>
            <td>{billableNephrectomy.donor.alias}</td>
            <td>{billableNephrectomy.recipient.center.alias}</td>
            <td>{billableNephrectomy.recipient.alias}</td>
            <td>{claimType}</td>
            <td>${total.toLocaleString('en', { minimumFractionDigits: 2 })}</td>
            <td>{billableNephrectomy.statusAbbreviation}</td>
            <td style={{ textAlign: 'center' }}>
                <button className='btn btn-primary btn-xs' onClick={handleViewCharges}>View Payment</button>
            </td>
        </tr>
    );
}

export default SubmittedByRecipientCenterRow;